import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight';

import React from 'react';
import style from '../../onboard-cards.module.less';
import { Link } from 'react-router-dom';

import { FlexColumn } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { BASE_ORDERS_PATH, BASE_STORE_SETUP_URL } from '../../../../../../routes/constants';
import { useHomePageOnboardContext } from '../../../../home-page-onboard-context';

import { messages } from '../../messages';
import classnames from 'classnames';

export const OrderImportCardFooterComplete = () => {
  const { closePopupGuide } = useHomePageOnboardContext();
  return (
    <FlexColumn>
      <Link className={classnames(style['complete-button'], style['link-button'])} onClick={closePopupGuide} to={BASE_STORE_SETUP_URL}>
        <Text textType={TextType.Caption} value={messages.connectAndManageStores} />
        <FontAwesomeIcon className={style.arrow} icon={faArrowRight} />
      </Link>
      <Link className={classnames(style['complete-button'], style['link-button'])} onClick={closePopupGuide} to={BASE_ORDERS_PATH}>
        <Text textType={TextType.Caption} value={messages.gotToOrders} />
        <FontAwesomeIcon className={style.arrow} icon={faArrowRight} />
      </Link>
    </FlexColumn>
  );
};
